import { Box, Button, ButtonAppearance, Heading, inputMediumStyles, ModalBody, ModalHeader } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';
import styled, { css } from 'styled-components';

export const WorkPackageListContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ListStyled = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  height: 100vh;
`;

export const SearchContainerStyled = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const PaginationContainerStyled = styled(Box).attrs({
  py: { sm: '400' },
  justifyContent: { sm: 'center' },
})`
  border-top: 2px solid ${({ theme }) => theme.colors.grey[200]};
  z-index: 1;
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export const WorkPackageHeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    display: flex;
    background-color: ${theme.colors.grey[200]};
    padding-top: ${theme.spacings[600]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const WorkPackageHeaderTitleStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    color: ${theme.colors.grey[1000]};
    margin: 0;
  `}
`;

export const PlanAIButtonStyled = styled(Button)`
  ${({ theme }) => css`
    min-height: 28px;
    padding-left: ${theme.spacings[450]};
    padding-right: ${theme.spacings[450]};
    padding-top: ${theme.spacings[400]};
    padding-bottom: ${theme.spacings[400]};
    white-space: nowrap;
    text-align: center;
    background: var(--Background-Star-Default, #722ed1);
    width: 110px;
    margin-left: 10px;
    &:hover:not(:disabled) {
      background: var(--Background-Star-Default, #722ed1);
    }

    &:active:not(:disabled) {
      background: var(--Background-Star-Default, #722ed1);
    }
  `}
`;

export const PlanAIButtonTextStyled = styled.span`
  color: var(--text-white, white);
  font-size: 12px;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  word-wrap: break-word;
`;

export const PlanAIButtonContentStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  display: flex;
  gap: 4px;
`;

export const AiModalHeaderStyled = styled(ModalHeader)`
  ${({ theme }) => css`
    min-width: ${theme.breakpoints.mobile};
    background: ${theme.colors.grey[400]};
  `}

  h1 {
    color: ${({ theme }) => theme.colors.grey[1000]};
    font-weight: ${({ theme }) => theme.fontWeights[600]};
  }
  button {
    background: none;
    color: ${({ theme }) => theme.colors.grey[1000]};
    &:hover {
      background-color: ${({ theme }) => theme.colors.grey[400]};
    }
  }
`;

export const AiModalBodyStyled = styled(ModalBody)`
  flex-direction: column;
`;

export const AiModalFooterStyled = styled(Box).attrs({
  p: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    box-shadow:
      0 2px 4px -1px rgb(0 0 0 / 20%),
      0 1px 10px 0 rgb(0 0 0 / 12%),
      0 4px 5px 0 rgb(0 0 0 / 14%);
    width: 100%;
  `}
`;

export const AiModalFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    height: 36px;
    min-width: 84px;
    padding-left: ${theme.spacings['500']};
    padding-right: ${theme.spacings['500']};
    padding-top: ${theme.spacings['400']};
    padding-bottom: ${theme.spacings['400']};
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    display: flex;
  `}
`;

export const AiModalFooterButtonPrimaryStyled = styled(AiModalFooterButtonStyled).attrs({
  appearance: ButtonAppearance.PRIMARY,
})`
  ${({ theme }) => css`
    background: #2c3e45;
    color: white;
    &:hover {
      background: #1f3238;
    }
  `}
`;

export const AiModalFooterButtonSecondaryStyled = styled(AiModalFooterButtonStyled).attrs({
  appearance: ButtonAppearance.SECONDARY,
})`
  ${({ theme }) => css`
    background: white;
    color: #656565;
    outline: 1px #c7c7c7 solid;
    outline-offset: -1px;
    &:hover {
      background: #f5f5f5;
    }
  `}
`;

export const AiToastContentStyled = styled(Box)`
  /* Hide the close (x) button in the parent Alert */
  & ~ button {
    display: none;
  }
`;
